import { render, staticRenderFns } from "./OutroScene.vue?vue&type=template&id=3aabbd1a&scoped=true&lang=pug&"
import script from "./OutroScene.vue?vue&type=script&lang=js&"
export * from "./OutroScene.vue?vue&type=script&lang=js&"
import style0 from "./OutroScene.vue?vue&type=style&index=0&id=3aabbd1a&lang=scss&scoped=true&"
import style1 from "./OutroScene.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aabbd1a",
  null
  
)

export default component.exports